import colors from '../colors.js';
var i = colors("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");
export { i as default };
//# sourceMappingURL=Pastel2.js.map
